import React, { useEffect, useState } from 'react';
import ControlPanelApp from '@zawarski/palmetto-typescript-control-panel';
import IncidentsApp from '@zawarski/palmetto-typescript-incidents';
import PositionsApp from '@zawarski/palmetto-typescript-positions';
import { AppAdminList } from '@/common/enum';
import { useContainerDimensions } from 'hooks/useContainerDimensions';
import { useAppSelector } from 'store/hooks';
import { jwtSelector, userAdminSelector } from 'store/auth/auth.selector';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from 'hooks/useMediaQuery';

interface IProps {
  app: AppAdminList;
  open: boolean;
  onClose: () => void;
}

const ModalAppWrapper: React.FC<IProps> = ({ app, open, onClose }) => {
  const token = useAppSelector(jwtSelector);
  const isUserAdmin = useAppSelector(userAdminSelector);

  // const { containerRef, dimensions } = useContainerDimensions(open);
  const { windowDimensions } = useMediaQuery();

  const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max));

  const calculateDimensions = (w: number, h: number) => {
    const adjustedWidth = w < 1232 ? w - 32 : w;
    return {
      width: clamp(adjustedWidth, 360, 1200),
      height: clamp(h, 600, 720),
    };
  };

  const [dimensions, setDimensions] = useState(() =>
    calculateDimensions(windowDimensions.width, windowDimensions.height)
  );

  useEffect(() => {
    setDimensions(calculateDimensions(windowDimensions.width, windowDimensions.height));
  }, [windowDimensions]);

  return (
    <>
      {open && (
        <div
          className={
            'fixed top-0 w-full h-full bg-[rgba(0,0,0,0.75)] flex items-center justify-center'
          }
          style={{ zIndex: 1051 }}>
          <div className='fixed inset-0 bg-opacity-0' onClick={onClose} />
          <div
            className='bg-white shadow-xl overflow-hidden min-w-[360px] min-h-[600px] w-auto h-auto m-4'>
            <div
              className={
                'flex w-full bg-vulcan-700 justify-between items-center py-1 px-2 text-white'
              }>
              <p className={'text-sm'}>{app}</p>
              <CloseIcon onClick={onClose} fontSize={'medium'} className={'pl-2 cursor-pointer'} />
            </div>
            {app === AppAdminList.Incidents && dimensions.width > 0 ? (
              <IncidentsApp
                isAdmin={isUserAdmin}
                userAuth={{ jwt: token }}
                dimensions={dimensions}
              />
            ) : app === AppAdminList.Positions ? (
              <PositionsApp userAuth={{ jwt: token }} dimensions={dimensions} />
            ) : (
              <ControlPanelApp userAuth={{ jwt: token }} dimensions={dimensions} />
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default ModalAppWrapper;
